/**
 * Copyright (c) 2022-present TVM Engineering Authors.
 */

import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { createTheme } from "@mui/material/styles";
import { Grid, Typography, ThemeProvider } from "@mui/material";
import SINGUP_BACKGROUND from "../assets/img/landing_main_background.png";
import LoadingScreen from "../components/feedback/LoadingScreen";
import { isLoading } from "../reducers/app";

const Imprint = React.memo((/* props: Props */) => {
  const theme = () =>
    createTheme({
      components: {
        MuiTypography: {
          styleOverrides: {
            root: {
              fontSize: "1.5rem",
              fontWeight: "300",
            },
          },
        },
      },
    });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  const {
    // user,
    isPageLoading,
  } = useSelector((globalState) => ({
    // user: getUserData(globalState),
    isPageLoading: isLoading(globalState),
  }));

  if (isPageLoading) {
    return <LoadingScreen />;
  }

  return (
    <ThemeProvider theme={theme()}>
      <div style={classes.root2}>
        <Grid container sx={classes.container85}>
          <Grid item xs={12}>
            <Typography component="strong" sx={classes.pageTitle}>
              Imprint
            </Typography>
            <Typography component="strong" sx={classes.title}>
              Elmos Semiconductor Sales & Solutions GmbH
            </Typography>
            <Typography component="p">Heinrich-Hertz-Straße 1</Typography>
            <Typography component="p">D-44227 Dortmund</Typography>
            <Typography component="p">Germany</Typography>
            <Typography component="p">Tel.: +49 (0) 231 / 75 49-0</Typography>
            <Typography component="p">Fax.: +49 (0) 231 / 75 49-149</Typography>
            <Typography component="p">www.elmos.com</Typography>
            <Typography component="strong" sx={classes.title}>
              Company information:
            </Typography>
            <Typography component="p">Managing: Jörn Conze, Margarita Mamberger</Typography>
            <Typography component="p">Register: Amtsgericht Dortmund</Typography>
            <Typography component="p">Registration number: HRB 36230</Typography>
            <Typography component="p">
              Company name: Elmos Semiconductor Sales & Solutions GmbH
            </Typography>
            <Typography component="p">
              Headquarters: Heinrich-Hertz-Straße 1, D-44227 Dortmund, Germany
            </Typography>
            <Typography component="p">Financial department: Dortmund</Typography>
            <Typography component="p">UST-ID: DE 369658367</Typography>
            <Typography component="p">Elmos-St.-Nr.: 315/5781/1777</Typography>
            <Typography component="strong" sx={classes.title}>
              Journalistic content
            </Typography>
            <Typography component="p">
              Responsible according to § 55 paragraph 2 of RStV: Waldemar Stephan (address as above)
            </Typography>
            <Typography component="strong" sx={classes.title}>
              Responsibility for homepage contents
            </Typography>
            <Typography component="p">
              We used the greatest care in creating the contents of this homepage. However, we
              cannot guarantee the accuracy, completeness or timeliness of the content. According to
              § 6 paragraph 1 of MDStV and § 8 paragraph 1 of TDG, we are responsible for our own
              content provided on these pages under the general laws. The service provider is not
              liable for monitoring transmitted or stored information or for investigating
              circumstances that indicate illegal activity. Obligations to remove or block the use
              of information under the general laws remain unaffected. As service provider, we are
              only liable for a specific infringement from the date we gained knowledge of it. We
              will remove such content immediately as soon as we are notified of such an
              infringement.
            </Typography>
            <Typography component="strong" sx={classes.title}>
              Responsibility for links
            </Typography>
            <Typography component="p">
              Our site includes links to external websites that are beyond our control. Therefore,
              we cannot accept legal responsibility for such websites. Only the providers or
              operators of the linked pages are responsible for their content. At the time this
              homepage was created, the linked sites were checked for possible violations of law
              which were not found at the time of linking. For us, a permanent control of the linked
              pages is unreasonable without concrete evidence of a violation. When notified of
              violations, we will remove such links immediately.
            </Typography>
            <Typography component="strong" sx={classes.title}>
              Copyright
            </Typography>
            <Typography component="p">
              The operators of these pages make a constant effort to respect the copyrights of
              others, and to utilize self-produced and license-free content. German copyright law
              governs content and works created by the page operators and presented on these pages.
              Contributions from third parties are identified as such. Reproduction, processing,
              dissemination and any type of use beyond what is permitted under copyright requires
              written authorisation from the respective author and/or the manufacturer. Copies and
              downloads are only allowed to be used in a private and non-commercial way.
            </Typography>
            <Typography component="strong" sx={classes.title}>
              Data privacy
            </Typography>
            <Typography component="p">
              If personal data are collected on our pages (such as names, addresses and e-mail
              addresses), this is as far as possible on a voluntary basis. Whenever feasible, it is
              always possible to make use of the offerings and services without providing any
              personal data. The use of the published contact data within the framework of the
              imprint regulations by third parties for the consignment of advertisements and
              information, which was not specifically ordered, is herewith explicitly objected to.
              Should the operator receive unsolicited promotional material, such as spam etc., the
              operator expressively reserves the right to take legal action. Source: Disclaimer from
              eRecht24, the portal to the Internet right
            </Typography>
          </Grid>
        </Grid>
      </div>
    </ThemeProvider>
  );
});

export default Imprint;

const classes = {
  root2: {
    minHeight: "750px",
    background: "#DDE5EF",
    overflowX: "hidden",
    overflowY: "hidden",
    padding: 20,
    backgroundImage: `url(${SINGUP_BACKGROUND})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    // fontWeight: '300',
  },
  container85: {
    width: "85%",
    margin: "0 auto",
    minHeight: "750px",
    background: "#fff",
    padding: "15px 30px",
    fontWeight: "300",
  },
  pageTitle: {
    color: "#1f577b",
    fontSize: "1.9rem",
    fontWeight: "500",
    marginBottom: "15px",
    marginTop: "50px",
  },
  numTitle: {
    fontWeight: "500",
    display: "block",
    marginBottom: "10px",
    fontSize: "1.5rem",
    marginTop: "20px",
  },
  title: {
    fontWeight: "500",
    display: "block",
    marginBottom: "10px",
    marginTop: "20px",
  },
  bullets: {
    padding: "10px 0px",
  },
};
